/*
 * Copyright (c) 2022-2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {Injectable} from '@angular/core';
import {CanActivate} from '@angular/router';
import {UserService} from '../../shared/user.service';
import {OAuthService} from 'angular-oauth2-oidc';

/***
 * Created by Ryan Pham
 */

@Injectable({
    providedIn: 'root'
})
export class AuthGuardService implements CanActivate {
    private userService: UserService;
    private oAuthService: OAuthService;

    constructor(userService: UserService, oAuthService: OAuthService) {
        this.userService = userService;
        this.oAuthService = oAuthService;
    }

    canActivate(): boolean {
        // Double check that we have valid tokens before trying to route to any content.
        if (this.oAuthService.hasValidIdToken() && this.oAuthService.hasValidAccessToken()) {
            return true;
        } else {
            return false;
        }
    }
}
